import qs from 'query-string';

// Utils
import isomorphicCookies from './isomorphicCookies';

const neededReferrers = [
  'google',
  'yandex',
  'yahoo',
  'go.mail',
  'rambler',
  'bing',
  'DuckDuckGo',
  'Baidu',
  'ecosia',
];

export default function adTest() {
  const { bannerId, utm_yclid, utm_gclid } = qs.parse(window.location.search);
  let ab_test_version = isomorphicCookies().get('ab_test_version');

  // если в ссылке есть bannerId, то ставим исходную группу
  if (bannerId) {
    isomorphicCookies().set('ab_test_version', 0, { expires: 60 });
    ab_test_version = 0;
  } else if (ab_test_version !== '0' && ab_test_version !== '1') {
    const newValue = Math.round(Math.random());
    isomorphicCookies().set('ab_test_version', newValue, { expires: 60 });
    ab_test_version = newValue;
  }

  const abTestData = {
    expId: 'zu9SutVFT0O8TzH9cR03HA', // Параметр
    expVar: ab_test_version, // 0 - исходный вариант группы, 1 - тестовая группа
  };

  const documentReferrer = document.referrer;

  // отслеживаем откуда перешел клиент
  if (
    neededReferrers.some(referrer => documentReferrer.includes(referrer)) &&
    !(utm_gclid || utm_yclid)
  ) {
    abTestData.referrer = documentReferrer;
  }

  window.dataLayer.push(abTestData);
}
